@defer (when !isInitializing()) {
@if (!loginDisplay) {
  <router-outlet></router-outlet>
}

@if (loginDisplay) {
  <app-shell>
    <router-outlet></router-outlet>
  </app-shell>
}
} @loading (minimum 2s) {
<div class="splash-screen">
  <div class="splash-content">
    <div class="loading-spinner"></div>
    <h2>{{ title }}</h2>
    <p>Initializing application...</p>
  </div>
</div>
} @placeholder {
<div class="splash-screen">
  <div class="splash-content">
    <div class="loading-spinner"></div>
    <h2>{{ title }}</h2>
    <p>Starting up...</p>
  </div>
</div>
}

<p-toast />
<p-confirm-dialog></p-confirm-dialog>

@if (reloadNeeded()) {
  <div class="new-version-popup-overlay">
    <div class="new-version-popup">
      <div class="popup-icon">🔄</div>
      <h3>New Version Available</h3>
      <p>A new version with updated data and constants is ready.</p>
      <p><strong>Please save your work and click below to reload.</strong></p>
      <button
        class="reload-button"
        (click)="reloadApplication()"
        type="button">
        Reload Application
      </button>
    </div>
  </div>
}

<!-- Global PDF Viewer -->
<app-pdf-viewer></app-pdf-viewer>

<!-- Global DOCX Viewer -->
<app-docx-viewer></app-docx-viewer>
